import { rewardAxios } from '../../../../http-common';

class RewardsDataService {
  getRewardsData() {
    return rewardAxios.get('');
  }
}
export default new RewardsDataService();
